import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentPage } from "../../redux/pagination/paginationSlice";

function Pagination({ results }) {
  const dispatch = useDispatch();
  const dictionary = useSelector((state) => state.localization.dictionary);

  function goToPage(nextPage) {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    dispatch(setCurrentPage(nextPage));
  }

  const pages = useMemo(() => {
    const pages = [];
    const currentPage = results?.currentPage;
    const totalPages = results?.totalPages;

    // handle current page that's in the last 3 pages
    if (currentPage + 1 >= totalPages && totalPages > 3) {
      if (currentPage == totalPages && totalPages > 4) {
        pages.push(currentPage - 4);
      }
      if (currentPage != 3) {
        pages.push(currentPage - 3);
      }
    }

    // handle 2 numbers before current page
    if (currentPage > 1 && totalPages > 1) {
      if (currentPage > 2 && totalPages > 2) {
        pages.push(currentPage - 2);
      }
      pages.push(currentPage - 1);
    }

    pages.push(currentPage);

    // handle 2 numbers after current page
    if (currentPage < totalPages) {
      pages.push(currentPage + 1);
      if (currentPage + 1 < totalPages) {
        pages.push(currentPage + 2);

        // handle current page that's 2 or lower
        if (currentPage < 3 && totalPages >= 4) {
          if (currentPage + 3 <= totalPages) {
            pages.push(currentPage + 3);
          }
          if (currentPage == 1 && totalPages > 4) {
            pages.push(currentPage + 4);
          }
        }
      }
    }

    return pages;
  }, [results?.currentPage, results?.totalPages]);

  return (
    <ul className="pagination" role="navigation" aria-label="Pagination">
      <li className="pagination-previous">
        <a
          aria-label="Previous Page"
          className={results.currentPage === 1 ? 'disabled' : ''}
          onClick={(evt) => {
            evt.preventDefault();
            goToPage(results?.currentPage - 1);
          }}
        >
          <span className="show-for-sr">
            {dictionary["CNHS.Pagination.PreviousPage"]}
          </span>
        </a>
      </li>
      {pages.map(
        (page, index) => (
          <li
            key={`pagination-item-${index}`}
            className={page === results?.currentPage ? "active" : ""}
          >
            <a
              onClick={(evt) => {
                evt.preventDefault();
                goToPage(page);
              }}
            >
              {page}
            </a>
          </li>
        )
      )}
      <li className="pagination-next">
        <a
          aria-label="Next Page"
          className={results.currentPage === results.totalPages ? 'disabled' : ''}
          onClick={(evt) => {
            evt.preventDefault();
            goToPage(results?.currentPage + 1);
          }}
        >
          <span className="show-for-sr">
            {dictionary["CNHS.Pagination.NextPage"]}
          </span>
        </a>
      </li>
    </ul>
  );
}

export default Pagination;
